import { key, notify } from '@databases/ping-registry';
import { getService } from '@databases/service-container';
import { createCellEditingEffect } from '@databases/value/cell-edit-effect';

import { type SelectionEffectFeature, SelectionFeatureKeys } from '../../features/types';

export function createCellEditingEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.CELL_EDITING_EFFECT,
    type: 'effect',
    factory: () =>
      createCellEditingEffect({
        selectionsApi: getService('SelectionsApi'),
        notifyCellEditing: (entryId: string, fieldId: string, editing: boolean) => {
          notify(key('cell', { entryId, fieldId }), 'editing', editing);
        },
      }),
  };
}
